<template>
    <div id="boxd">
        <img src="./../assets/合成-1_3.gif" alt="">
    </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
	name:'callback',
	data () {
        return {
        }
    },
    mounted(){
        this.inshow()
    },
    methods:{
        inshow(){
            var token =Cookies.get('token')
            if(token == token ){
                setTimeout(() => {
                    this.$router.push({path:"/"})
                }, 10);
            }
        }
    }
}
</script>

<style scoped>
#boxd{
    width: 100%;
    height: 840px;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 999999999999999999;
}
#boxd img{
    width: 100%;
    height: 100%;
}
</style>